// Shared display formatting for the Edge Review surfaces (sc-6127) — one
// definition for the page, the combined table, and the day drawer.

// Whole-dollar money: cents -> "$1,234"; nullish -> em dash.
export const formatCents = (cents: number | null | undefined): string =>
  cents == null ? '—' : `$${Math.round(cents / 100).toLocaleString()}`;

// Date-only strings (run_on etc.) must be anchored to local midnight — bare
// new Date('YYYY-MM-DD') parses as UTC and renders a day early in US zones.
export const formatDate = (value: string | null | undefined): string => {
  if (!value) return '—';
  const normalized = /^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T00:00:00` : value;
  return new Date(normalized).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
};

// Compact "M/D" label for the table's day columns.
export const formatDayLabel = (iso: string): string => {
  const [, m, d] = iso.split('-');
  return `${Number(m)}/${Number(d)}`;
};
